import React, { Component } from "react";
import axios from "axios";
import {
  bookClassApi,
  getClassApi,
  checkClassAvailability
} from "../../redux/actions/api/apiAction";
import { connect } from "react-redux";
import Footer from "../../components/footer/footer";
import { Row, Col, Modal, ModalBody } from "reactstrap";
import moment from "moment";
import Title from "../../components/title";
import { withNamespaces } from "react-i18next";
import { history } from "../../app/AppRouter";
import { toastr } from "react-redux-toastr";
import { ComonIcons } from "../../contents/commonIcons";

import {
  getUTCDateTime,
  getLocalDateTime
} from "../../services/convertTimeService";

class Checkout extends Component {
  state = {
    loading: true,
    checkoutId: "",
    waitingPopup: false
  };
  componentDidMount = async () => {
    const {
      match: { params }
    } = this.props;
    this.props.getClassApi(params.id);
    let isAvailable = await this.props.checkClassAvailability(params.id);
    if (isAvailable) {
      this.getCheckoutDetails(params);
    } else {
      this.toggleWaitingListPopup();
    }
  };

  getCheckoutDetails = async () => {
    const {
      match: { params }
    } = this.props;
    let res = await this.props.bookClassApi(params.id);
    if (res) {
      switch (res.status) {
        case 400:
          toastr.error(this.props.t(res.data.error));
          // console.log("error");
          history.push("/userinfo");
          break;
        case 200:
          this.setState({ checkoutId: res.data.data.id, loading: false });
          break;
        case 201:
          toastr.success(this.props.t(res.data.message));
          history.push("/userinfo");
          break;
        case 202:
          toastr.success(this.props.t(res.data.message));
          history.push("/userinfo");
          break;
      }
    }
  };

  toggleWaitingListPopup = () => {
    this.setState({ waitingPopup: !this.state.waitingPopup });
  };

  renderPaymentform = () => {
    // console.log("Loading ");
    const script2 = document.createElement("script");
    script2.innerHTML = `
      var wpwlOptions = {
        style: "card",
        locale:'${this.props.language}',
        paymentTarget: "_top",
        registrations: { requireCvv: true, hideInitialPaymentForms: true },
        maskCvv: true
      };
      `;
    document.body.appendChild(script2);
    const script = document.createElement("script");

    script.src = `https://oppwa.com/v1/paymentWidgets.js?checkoutId=${this.state.checkoutId}`;
    script.async = true;

    document.body.appendChild(script);
    let cardDisplay = document.getElementById("cardDisplay");

    const form = document.createElement("form");
    // form.action = "https://connecttofit.zignuts.dev/result";
    form.action = "https://www.connecttofit.com/result";
    form.setAttribute("class", "paymentWidgets");
    form.setAttribute("data-brands", "VISA MASTER");
    cardDisplay.appendChild(form);
  };
  componentWillUnmount = () => {
    if (window.wpwl !== undefined && window.wpwl.unload !== undefined) {
      window.wpwl.unload();
      let arrayScript = document.getElementsByTagName("SCRIPT");
      for (let i = 0; i < arrayScript.length; i++) {
        // console.log("Length", arrayScript[i]);
        if (
          arrayScript[i].src.indexOf("static.min.js") !== -1 ||
          arrayScript[i].src.indexOf("paymentWidgets.js") !== -1
        ) {
          arrayScript[i].remove();
        } else if (!arrayScript[i].src) {
          arrayScript[i].remove();
        }
      }
    }
  };
  render() {
    // if (!this.state.loading) {
    //     return (
    //         <div >
    //             {this.renderPaymentform()}
    //         </div>
    //     );
    // } else {
    //     return (
    //         <div> Still Loading ...</div>
    //     )
    // }
    return (
      <>
        <div className="account-info ctf-bg-sixth admin-card-block ">
          <div className="custom-container">
            <div className="section">
              <Row className="justify-content-center">
                <Col md={12} lg={12} xl={9}>
                  <div className="bg-white card-panel">
                    <div className="basic-info">
                      <div className="info-title with-border">
                        <Title
                          title={this.props.t("class_info")}
                          titlestyle=""
                          subtitlestyle="ctf-tx-secondary"
                          subtitle={""}
                        />
                      </div>
                      <div className="info-wrapper border-bottom-1 blk-padding-y">
                        <div className="info">
                          <Row>
                            <Col md={4}>
                              <div className="input-remain-content">
                                <p className="ctf-tx-secondary">
                                  {this.props.t("name")}
                                </p>
                                <h3 className="input-title">
                                  {" "}
                                  {this.props.classData.name
                                    ? this.props.classData.name
                                    : "Not Available"}
                                </h3>
                              </div>
                            </Col>
                            <Col md={8}>
                              <div className="input-remain-content">
                                <p className="ctf-tx-secondary">
                                  {this.props.t("price")}
                                </p>
                                <h3 className="input-title">
                                  {this.props.classData.price
                                    ? `${this.props.classData.price} JOD`
                                    : "Not Available"}
                                </h3>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="input-remain-content">
                                <p className="ctf-tx-secondary">
                                  {this.props.t("start_time")}
                                </p>
                                <h3 className="input-title">
                                  {this.props.classData.startDate
                                    ? moment(
                                        getLocalDateTime(
                                          this.props.classData.startDate,
                                          this.props.classData.from
                                        ).date
                                      ).format(
                                        `MMM DD YYYY ${
                                          getLocalDateTime(
                                            this.props.classData.startDate,
                                            this.props.classData.from
                                          ).time
                                        }`
                                      )
                                    : "Not Available"}
                                </h3>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className="action-wrapper blk-padding-y">
                        <div className="action-inner-block">
                          <div className="action-btn-block" id="cardDisplay">
                            {!this.state.loading && this.renderPaymentform()}
                            {this.state.loading && (
                              <h1>{`${this.props.t("please_wait")}...`}</h1>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.waitingPopup}
          // toggle={this.toggleWaitingListPopup}
          centered={true}
          className="medium delete-pop"
          size="md"
        >
          <ModalBody className="p-0 login-register-main-block">
            <div className="modal-body-content p-0">
              <div className="position-relative p-3 ">
                {/* <div className="close c-pointer" onClick={this.toggleWaitingListPopup}>
                {ComonIcons.closeSecond}
              </div> */}
                <div className="content">
                  <div className="delete-title">
                    <h2 className="">
                      {this.props.t("toast_book_class_title")}
                    </h2>
                  </div>
                  <div className="pb-0 pb-md-4">
                    <Row className="justify-content-center">
                      <Col sm={12}>
                        <p>{this.props.t("waiting_class_popup")}</p>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="action-btn-block py-3">
                  <button
                    type="button"
                    value=""
                    className=" btn btn-small btn-transparent"
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    {this.props.t("cancel")}
                  </button>
                  <button
                    type="button"
                    value=""
                    className=" btn btn-small"
                    onClick={() => {
                      this.getCheckoutDetails();
                    }}
                  >
                    {this.props.t("proceed")}
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* <div className>
              <Footer></Footer>
            </div> */}
      </>
    );
  }
}

const mapStateToProps = state => {
  const { language, direction } = state.languageDirectionData;
  const { classData } = state.classData;
  return { language, direction, classData };
};

export default connect(mapStateToProps, {
  bookClassApi,
  getClassApi,
  checkClassAvailability
})(withNamespaces()(Checkout));
